import { DObj_Inst_Property } from '../models/domain/dobj_inst_property';
import { CommonEnums } from '../common.enums';

export class DObj_Inst_PropertiesUtil {
    private static instance: DObj_Inst_PropertiesUtil;

    static getInstance() {
        if (!DObj_Inst_PropertiesUtil.instance) {
            DObj_Inst_PropertiesUtil.instance = new DObj_Inst_PropertiesUtil();
        }

        return DObj_Inst_PropertiesUtil.instance;
    }

    /**
    * DObj_Inst_PropertiesUtil is a singleton class, so use DObj_Inst_PropertiesUtil.getInstance() method instead of creating new DObj_Inst_PropertiesUtil().
    */
    private constructor() {

    }

    getPrimaryKey(dobj_Inst_Property: DObj_Inst_Property): string {
        return dobj_Inst_Property.dxFlow_Id + "." + dobj_Inst_Property.dxMp_Inst_Id + "." + dobj_Inst_Property.obj_Id;
    }

    copy(dobj_inst_properties: Array<DObj_Inst_Property>): Array<DObj_Inst_Property> {
        let dObj_Inst_PropertiesTmp: Array<DObj_Inst_Property> = new Array<DObj_Inst_Property>();

        for (var i: number = 0; i < dobj_inst_properties.length; i++) {
            let DObj_Inst_Property: DObj_Inst_Property = dobj_inst_properties[i] as DObj_Inst_Property;
            dObj_Inst_PropertiesTmp.push(DObj_Inst_Property.copy());
        }

        return dObj_Inst_PropertiesTmp;
    }

    copyFrom(dObj_Inst_Properties: Array<DObj_Inst_Property>, dxMp_Fwd_LnksTmp: Array<DObj_Inst_Property>): void {
        let dxMp_Fwd_LnksMap: Map<string, DObj_Inst_Property> = new Map();

        let dxMp_Fwd_LnkLength: number = dObj_Inst_Properties.length;
        for (let i: number = 0; i < dxMp_Fwd_LnkLength; i++) {
            let dxMp_Fwd_Lnk: DObj_Inst_Property = dObj_Inst_Properties[i] as DObj_Inst_Property;
            dxMp_Fwd_LnksMap.set(this.getPrimaryKey(dxMp_Fwd_Lnk), dxMp_Fwd_Lnk);
        }
        dObj_Inst_Properties.splice(0, dObj_Inst_Properties.length);


        let dObj_Inst_PropertiesTmpLength: number = dxMp_Fwd_LnksTmp.length;
        for (let i: number = 0; i < dObj_Inst_PropertiesTmpLength; i++) {
            let dObj_Inst_PropertiesTmp: DObj_Inst_Property = dxMp_Fwd_LnksTmp[i] as DObj_Inst_Property;
            let dObj_Inst_Property = dxMp_Fwd_LnksMap.get(this.getPrimaryKey(dObj_Inst_PropertiesTmp));
            if (dObj_Inst_Property) {
                dObj_Inst_Property.copyFrom(dObj_Inst_PropertiesTmp);
            } else {
                dObj_Inst_Property = DObj_Inst_Property.parse(dObj_Inst_PropertiesTmp);
            }
            dObj_Inst_Properties.push(dObj_Inst_Property);
        }
    }

    compare(dObj_Inst_Properties: Array<DObj_Inst_Property>, dObj_Inst_PropertiesTmp: Array<DObj_Inst_Property>): string {
        if (dObj_Inst_Properties.length != dObj_Inst_PropertiesTmp.length)
            return 'dObj_Inst_Properties length mismatch.';

        for (let i: number = 0; i < dObj_Inst_Properties.length; i++) {

            let dobj_Inst_Property: DObj_Inst_Property = dObj_Inst_Properties[i] as DObj_Inst_Property;
            let dobj_Inst_PropertyTmp: DObj_Inst_Property = dObj_Inst_PropertiesTmp[i] as DObj_Inst_Property;

            let diffString: string = dobj_Inst_Property.compare(dobj_Inst_PropertyTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }
        return '';
    }

    toString(dObj_Inst_Properties: Array<DObj_Inst_Property>): string {
        let str: string = '';
        str += 'DObj_Inst_Property length: ' + dObj_Inst_Properties.length + ' ';

        for (let i: number = 0; i < dObj_Inst_Properties.length; i++) {
            let DObj_Inst_PropertyTmp: DObj_Inst_Property = dObj_Inst_Properties[i] as DObj_Inst_Property;
            str += DObj_Inst_PropertyTmp.toString();
        }
        return str;
    }
}    